import store from 'app/store';
import * as types from 'app/actions/action_types';
import * as way from 'app/libs/core/PubSubWays';
import * as e from 'app/constants/TourBuilderEvents';
import tourPrevAPI from 'app/API/tour.prev.api';
import { tourPoint } from 'app/libs/map/drive/TourPoint';
import { Type } from 'app/constants/TourPoints';

function allPartsOnPage(
  actions,
  commonPage,
  dataPoly,
  useSubscribers,
  trigger
) {
  let fakePartData = [];

  const [{ sub }, setMediator] = useSubscribers();

  let countParts = 0;

  setMediator(this);

  commonPage.setMediator(this);
  dataPoly.setMediator(this);

  const clearCommonPage = () => {
    trigger.cleanData();
    commonPage.clearMultiData();
    dataPoly.clear();
    sub.destroy();
  };

  const distructItself = () => {
    clearCommonPage();
  };

  const getAvoidSettings = () => ({
    unpaved: actions.unpaved(),
    highway: actions.highway(),
    ferry: actions.ferry(),
  });

  const loadPartsOnPage = (data) => {
    fakePartData = [];
    countParts = data.parts.length;
    if (
      !commonPage.getCountParts() ||
      commonPage.getCountParts() !== countParts
    ) {
      const len = data.parts.length - 1;
      data.parts.forEach((part, i) => {
        if (!part.id) {
          fakePartData.push({ ...part, id: i + 1 });
        }
        const puth = [];
        const partId = part.id ? part.id : i + 1;
        part.points.forEach((point) => {
          if (!point.isEmpty) {
            if (point.type === Type.START || point.type === Type.END)
              commonPage.addPointToPart(
                { ...point, part: i + 1, partId, draggable: false },
                len === i
              );
            const { lat, lng } = point;
            if (lat && lng) puth.push(`${lng},${lat}`);
          }
        });
        dataPoly.showPartPolyline(puth, partId, getAvoidSettings());
      });
    }
  };

  const openMultiTourParts = (data) => {
    const { customId, partId } = data;
    if (+customId > 0) {
      const pageKey = commonPage.getPageKeyByPointId(customId);
      actions.actionPartByKey(pageKey);
    } else if (partId) {
      actions.actionPartByKey(partId);
    }
  };

  const getFakePartIdByPointId = (id) => {
    let partId;
    fakePartData.map((item) => {
      item.points.map((point) => {
        if (+point.id === +id) {
          partId = item.id;
        }
        return point;
      });
      return item;
    });
    return partId;
  };

  const selectMultiTourParts = (data) => {
    const { customId, partId } = data;
    const partD = partId || getFakePartIdByPointId(customId);
    const selectedPoint =
      partId && customId === undefined
        ? commonPage.getFirstPointByPartId(partD)
        : commonPage.getPointById(customId);
    const endPoint = commonPage.getLastPointByPartId(partD);
    if (customId === 0) {
      actions.setActivePoint({});
      trigger.selectePartFirstPoint();
      trigger.selectePartLastPoint(0);
    } else if (selectedPoint && typeof selectedPoint.part === 'number') {
      actions.setActivePoint({ ...selectedPoint });
      trigger.selectePartFirstPoint(selectedPoint.id);
      if (endPoint) trigger.selectePartLastPoint(endPoint.id);
    }
    trigger.selectePartPoly(partD);
  };

  const tourPartActionHandler = (obj) =>
    actions.tourPartActionHandler('topic', obj);

  const deleteTourPart = ({ customId }) => {
    const part = commonPage.getPartByPointId(customId).slice();
    const resp = {
      partId: 0,
      isMultyDay: actions.isMultyDay(),
    };
    part.forEach((point) => {
      trigger.removeTourPointOnMap(point.id);
      if (!resp.partId && point.partId) resp.partId = point.partId;
    });
    dataPoly.showPartPolyline(null, resp.partId);
    actions.deleteTourPart(resp);
  };

  const updatePartDistDurById = (data) => {
    actions.setDistanceDurationByPartId(data);
  };

  const saveMultiDayCopyToCreate = ({ tour, user }) => {
    setTimeout(() => {
      const newTour = { ...tour };
      delete newTour.id;
      newTour.points = newTour.points.map((item) => tourPoint(item));
      newTour.multiDay = true;
      newTour.parent_tour_id = 0;
      newTour.part_id = 0;
      newTour.user = user;
      tourPrevAPI.saveTour(newTour).then((res) => {
        if (res.code === 200) {
          store.dispatch({
            type: types.TOUR_FULL_DATA_ID,
            payload: { id: res.response.id, part: 0 },
          });
          if (newTour.parts && newTour.parts.length > 1) {
            newTour.parts.map((part) => {
              const p = { ...part };
              p.points = p.points.map((item) => tourPoint(item));
              p.parent_tour_id = res.response.id;
              p.user = user;

              tourPrevAPI.saveTour(p).then((resp) => {
                if (resp.code === 200) {
                  p.points = p.points.map((item) => tourPoint(item));
                  store.dispatch({
                    type: types.TOUR_FULL_DATA_ID,
                    payload: { id: resp.response.id, part: part.part_id },
                  });
                  if (newTour.parts.length === part.part_id) {
                    console.log('END OF SAVING PARTS');
                  }
                }
              });
              return part;
            });
          }
        }
      });
    }, 2000);
  };

  const getTourDistDuration = (tour) => {
    const data = {
      distance: 0,
      duration: 0,
    };
    tour.points.map((point) => {
      if (point.distance) {
        data.distance += point.distance;
      }
      if (point.duration) {
        data.duration += point.duration;
      }

      return null;
    });

    return data;
  };

  const saveFirstPartMultiday = (tour) => {
    const newTour = { ...tour };
    const firstPart = { ...newTour.parts[0] };
    if (firstPart.id) {
      delete firstPart.id;
    }
    const { distance, duration } = getTourDistDuration(firstPart);
    firstPart.title = 'Part 1';
    firstPart.description = '';
    firstPart.images = [];
    firstPart.imgids = '';
    firstPart.lat = firstPart.points[0].lat;
    firstPart.lng = firstPart.points[0].lng;
    firstPart.points = firstPart.points.map((item) => tourPoint(item));
    firstPart.owner = +newTour.user.id;
    firstPart.multiDay = true;
    firstPart.duration = duration;
    firstPart.distance = distance;
    firstPart.parent_tour_id = +newTour.id;
    firstPart.multiDay = true;
    firstPart.part_id = 1;
    firstPart.user = newTour.user;
    tourPrevAPI.saveTour(firstPart).then((res) => {
      // need to save via autoSaveTour.js
      if (res.code === 200) {
        store.dispatch({
          type: types.SAVE_FIRST_DAY_WHEN_MULTIDAY_ON,
          payload: {
            ...firstPart,
            id: res.response.id,
            points: firstPart.points,
          },
        });
      }
    });
  };

  const optimizeAllTourParts = () => {
    actions.optimizeAndSaveTour();
  };

  const showPartPoint = (point) => {
    trigger.showPartPointOnMap(point);
    if (countParts === point.part && point.type === Type.END) {
      actions.disableReloadCommonPage();
      if (actions.wasJustImported()) trigger.entireTour();
    }
  };

  const showPolyStrOnMap = ({ latLngs, pointId, partId }) => {
    trigger.showPolyStrOnMap({
      latLngs,
      isEdit: actions.getCurrentMode(),
      pointId,
      partId,
    });
  };

  const changePointPolyOnMap = (obj) => trigger.changePointPolyOnMap(obj);

  const movePointPoly = (obj) => {
    trigger.movePointPoly(obj);
  };

  const possiblylity = {
    [e.ATP_DISTRUCT_ITSELF]: distructItself,
    [e.ATP_CLEAR_PART_DATA]: clearCommonPage,
    [e.ATP_SET_SUBSCRIBERS_FROM_VIEW]: sub.set,
    [e.ATP_LOAD_TOUR_DATA_ALL_PARTS]: loadPartsOnPage,
    [e.ATP_CREATE_POINT_ON_MAP]: showPartPoint,
    [e.TB_POLY_DRIVE_MAP_CHANGE_POLY]: showPolyStrOnMap,
    [e.TB_POLY_DRIVE_MAP_CHANGE_POINT_POLY]: changePointPolyOnMap,
    [e.TB_POLY_DRIVE_MAP_MOVE_POINT_POLY]: movePointPoly,
    [e.ATP_UPDATE_DISTANCE_DURATION_PART_BY_ID]: updatePartDistDurById,

    [way.DRIVE_MAP_STATIC_POINT_SELECTED]: openMultiTourParts,
    [way.DRIVE_MAP_STATIC_POINT_MOUSEENTER]: selectMultiTourParts,
    [way.DRIVE_BUILDER_PART_ACTION]: tourPartActionHandler,
    [way.BUILDER_MAP_REMOVE_PART]: deleteTourPart,
    [way.SAVE_FIRST_PART_MULTIDAY]: saveFirstPartMultiday,
    [way.SAVE_MULTI_DAY_COPY_TO_CREATE]: saveMultiDayCopyToCreate,
    [way.CORRECT_ALL_WRONG_ROUTES_ON_ALL_PAGES]: optimizeAllTourParts,
  };

  const getCommand = (event) => possiblylity[event];

  this.notify = (event, data) => {
    const command = getCommand(event);
    if (command) {
      command(data);
    } else {
      console.error(`There is no command for event - ${event}`);
    }
  };
}

export default allPartsOnPage;
